export const FormatPriceShortenedNotationHelper = (value , displayCurrency) => {
  if (value === 0 || value === null || value === undefined || value === "" || value ==='0')
        return "–";
  let priceValue = value;

  if (typeof value === "string")
    priceValue = parseInt(value.replace(/,/g, "").split(".")[0]);
  else if (typeof value === "number") priceValue = parseInt(value);


  if (isNaN(priceValue)) return "–";

  const absValue = Math.abs(priceValue);

  if (absValue >= 1_000_000_000) {
    return `${(priceValue / 1_000_000_000).toFixed(
      priceValue % 1_000_000_000 === 0 ? 0 : 2
    )}B ${displayCurrency ?  displayCurrency : ""}`;
  } else if (absValue >= 1_000_000) {
    return `${(priceValue / 1_000_000).toFixed(
      priceValue % 1_000_000 === 0 ? 0 : 2
    )}M ${displayCurrency ?  displayCurrency : ""}`;
  } else if (absValue >= 999500) {
    return `${(priceValue / 1_000_000).toFixed(0)}M ${displayCurrency ?  displayCurrency : ""}`;
  } else if (absValue >= 1000) {
    return `${(priceValue / 1000).toFixed(priceValue % 1000 === 0 ? 0 : 2)}K ${displayCurrency ?  displayCurrency : ""}`;
  }

  return `${priceValue} ${displayCurrency ?  displayCurrency : ""}`;
};
